import { GuestRestrictions, SearchListingStatus } from '../graphql'

export const breakpoints = {
    xxs: '360px',
    xs: '600px',
    sm: '960px',
    md: '1280px',
    lg: '1920px',
    xxsMax: '359px',
    xsMax: '599px',
    smMax: '959px',
    mdMax: '1279px',
    lgMax: '1919px'
}

export const dialogWidth = {
    lg: '1000px',
    md: '800px',
    sm: '700px',
    xs: '600px',
    xxs: '360px'
}
export const millisecondsInADay = 1000 * 60 * 60 * 24
export const oneMicro = 1_000_000
export const searchListingsCriteriaKey = 'searchListings.criteria.v3'
export const searchMapCenterKey = 'searchMap.center.v1'
export const activeWishlistKey = 'wishlist.active.v1'
export const wishlistStatusKey = 'wishlist.status.v1'
export const presentmentCurrencyKey = 'presentmentCurrency'
export const onboardingStorageKeys = {
    inviteePhoneNumber: 'inviteePhoneNumber',
    inviteCode: 'inviteCode',
    inviteRedirectUrl: 'inviteRedirectUrl',
    inviteRole: 'inviteRole',
    inviteAsset: 'inviteAsset',
    signupTravelAgentRequest: 'signupTravelAgentRequest',
    signupConsumerRequest: 'signupConsumerRequest'
}
export const textSearchStorageKeys = {
    textSearchProperties: 'textSearchProperties',
    textSearchDestinations: 'textSearchDestinations'
}
export const consumerViewStorageKeys = {
  consumerView: 'consumerView',
  companyLogo: 'consumerBrandingCompanyLogo'
}

export const emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';

export enum ThemeColor { Accent = 'accent', Primary = 'primary', Warn = 'Warn' }

export const placeHolderSearchListing = {
    listingId: '',
    summary: {
        photos: [],
        listingPhotos: [],
        title: '',
        highlightedAmenities: [],
        houseRules: {
            rules: []
        },
        decidingFactors: {
            primaryDecidingFactors: []
        },
        highlightedFeatures: {
            listingId: '',
            features: []
        },
        assetDescription: '',
        listingDescription: ''
    },
    asset: {
        assetId: '',
        documentLibrary: {
            documentLibraryId: '',
            documents: []
        }
    },
    obfuscatedLocation: {
        range: 6,
        location: null
    },
    status: SearchListingStatus.Available
}

export const defaultGuestRestrictions: GuestRestrictions = {
    maxOccupancy: 100,
    ageRanges: [
        {
            key: 'adults',
            labelPrefix: 'Adults',
            minAge: 18,
            maxAge: 0,
            allowed: true,
            maxNumberAllowed: 100,
            minNumberAllowed: 1,
        },
        {
            key: 'children',
            labelPrefix: 'Children',
            minAge: 2,
            maxAge: 18,
            allowed: true,
            maxNumberAllowed: 99,
            minNumberAllowed: 0,
        },
        {
            key: 'infants',
            labelPrefix: 'Infants',
            minAge: 0,
            maxAge: 2,
            allowed: true,
            maxNumberAllowed: 99,
            minNumberAllowed: 0,
        },
    ]
}

export const socialConnections = {
    google: 'google-oauth2',
    microsoft: 'windowslive'
}
